import { LightningElement, api } from "lwc";
import type { CardSummary } from "./types";
export type { CardSummary };

export default class Card extends LightningElement {
  @api cardsummary: CardSummary = null!;
  @api descriptionlines = 4;

  private get hasCardSummary() {
    return this.cardsummary !== null; 
  }

  //To return Card Border Color
  private get cardTopBorderColor() {
    return "border-top-color:"+ this.cardsummary.bordercolor;
  }

  //To Contitionally Display Html Components
  private get showImage() {
    return this.cardsummary.tilemode === "certificate";
  }

  private get titleLines() {
    return ["certificatePrep", "bootcamp"].includes(this.cardsummary.tilemode) ? "3" : "2";
  }

  private get showSubtitle() {
    return ["course", "bootcamp"].includes(this.cardsummary.tilemode);
  }

  private get showBadge() {
    return ["course", "event", "certificate"].includes(this.cardsummary.tilemode);
  }

  private get showDescription() {
    return ["course", "event", "certificatePrep", "bootcamp"].includes(this.cardsummary.tilemode);
  }

  private get showDuration() {
    return ["course", "certificatePrep", "bootcamp"].includes(this.cardsummary.tilemode);
  }

  private get showLink() {
    return ["event", "certificate"].includes(this.cardsummary.tilemode);
  }
}
